import { OccupancySeries, PresenceSeriesParams } from '@hakimo-ui/hakimo/types';
import useAuthenticatedRequest from '../shared/useAuthenticatedRequest';
import { seriesQueryString } from './seriesQuery';

export function useZoneOccupancy(
  zoneId: string,
  params: PresenceSeriesParams = {},
  enabled = true
) {
  const query = seriesQueryString(params);
  const url = `/v2/orm/presence/zones/${zoneId}/occupancy${query}`;
  const request = new Request(url);

  return useAuthenticatedRequest<OccupancySeries>(request, {
    queryKey: ['presence-occupancy', zoneId, query],
    responseModifier: async (response) => {
      const respJson = await response.json();
      return respJson.payload;
    },
    staleTime: 60 * 1000,
    enabled,
  });
}

export default useZoneOccupancy;
